// ***************************************
// themeController
//
// This function returns the settings for the theme.
// It is used in the constructor for the theme controller.
//
// This version is just a template.
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 12-10-2015
// ***************************************
export var themeSettings = function () {
    "use strict";
    return {
        // Required theme related settings
        theme: {
            name: "<UNKNOWN>",
            id: "<UNKNOWN>",
            version: "1.0" // Version of the theme
        },
        // Specific flow settings that override the default flow settings
        flow: {}
    };
};
